<template>
  <div class="base-wrapper" ref="basewrapper" v-on:keyup.40="pageIndex < maxIndex ? pageIndex++ : null" v-on:keyup.38="pageIndex > 0 ? pageIndex-- : null"  tabindex="-1">

    <Header id="section-0" :data="{
        header: 'These are some charts.',
        subheader:'I really hope you enjoy how they are laid out',
        dark: false,
    }"></Header>

    <div id="section-1" class = "uk-section section-full-page uk-section-large">

      <!--<donut-chart></donut-chart>-->
      <scatter-set></scatter-set>

    </div>

    <div id="section-2" class = "uk-section section-full-page uk-section-large">
      <grouped-bar :data="groupedBarData"></grouped-bar>
    </div>

    <div id="section-3" class="uk-section section-full-page uk-section-large">
      <h2 class ="uk-text-muted">Weekly Volume</h2>
      <div class="uk-position-relative uk-visible-toggle uk-dark" tabindex="-1" uk-slider="center: true">

        <ul class="uk-slider-items uk-grid">
          <li class="uk-width-2-5@m">
            <solar-chart></solar-chart>
          </li>
           <li class="uk-width-2-5@m">
            <solar-chart></solar-chart>
          </li>
           <li class="uk-width-2-5@m">
            <solar-chart></solar-chart>
          </li>
           <li class="uk-width-2-5@m">
            <solar-chart></solar-chart>
          </li>
           <li class="uk-width-2-5@m">
            <solar-chart></solar-chart>
          </li>
        </ul>

        <a class="uk-position-center-left uk-position-small uk-hidden-hover" href="#" uk-slidenav-previous
           uk-slider-item="previous"></a>
        <a class="uk-position-center-right uk-position-small uk-hidden-hover" href="#" uk-slidenav-next
           uk-slider-item="next"></a>

      </div>
    </div>

    <div class="uk-section">
      <div id = "simple-line-chart-example">
        <simple-line :data="[{value: 10}, {value: 20}, {value: 30}, {value: 15}, {value: 11},]" color="blue"/>
      </div>
    </div>

    <div class="uk-section uk-section-primary">
      <div id = "simple-stacked-bar-chart-example">
        <simple-stacked-bar/>
      </div>
    </div>


  </div>
</template>

<script>



    const delivered_data = [
    {
        "groupName": "this_month",
        "data": [
            {
                "date": "2019-04-01T00:00:00Z",
                "label": "volume",
                "value": 37277,
                "value_type": "number"
            },
            {
                "date": "2019-04-01T00:00:00Z",
                "label": "tow_volume",
                "value": 16472,
                "value_type": "number"
            },
            {
                "date": "2019-04-01T00:00:00Z",
                "label": "cancelled_freq",
                "value": 0.0320676237756608,
                "value_type": "percentage"
            }
        ]
    },
    {
        "groupName": "prev_month",
        "data": [
            {
                "date": "2019-03-01T00:00:00Z",
                "label": "volume",
                "value": 39029,
                "value_type": "number"
            },
            {
                "date": "2019-03-01T00:00:00Z",
                "label": "tow_volume",
                "value": 16630,
                "value_type": "number"
            },
            {
                "date": "2019-03-01T00:00:00Z",
                "label": "cancelled_freq",
                "value": 0.0293145419602819,
                "value_type": "percentage"
            }
        ]
    }
]


  import Header from "./theme/Header.vue"
  import DonutChart from "./charts/DonutChart.vue"
  // import ZoomBrushChart from './charts/ZoomBrushChart'
  import SolarChart from './charts/SolarChart'
  import GroupedBar from './charts/GroupedBar'
  import ScatterSet from '@/components/charts/ScatterSet.vue'

  import SimpleLine from "./charts/SimpleLine.vue"
  import SimpleStackedBar from "./charts/SimpleStackedBar.vue"

	export default {
		name: 'Charts',
    components: {
	    ScatterSet,
			Header,
			DonutChart,
			// ZoomBrushChart,
			SolarChart,
      GroupedBar,
      SimpleLine,
      SimpleStackedBar,
		},
		data: function () {
			return {
				pageIndex: 0,
        maxIndex: 4,
        scrollY: 0,
        groupedBarData: delivered_data
			}
		},
		computed: {
			nextTarget: function () {
				const next = this.pageIndex + 1;
				const target = "#section-" + next
        return target
			},
      prevTarget: function () {
				let prev = this.pageIndex - 1 ;
				prev = prev > 0 ? prev : 0;
				const target = "#section-" + prev
        return target
			}
		},
    watch: {
			pageIndex() {
				console.log(this.pageIndex);
				this.scrollToSection("#section-" + this.pageIndex)
      }
    },
		methods: {
			scrollToSection:  function(target) {
				this.$scrollTo(target, 400)
			},
			handleUserScroll() {
				this.scrollY = window.scrollY;
			}
		},
		mounted() {
			this.$refs.basewrapper.focus();
		},
		created() {
			window.addEventListener('scroll', this.handleUserScroll);

    },
		destroyed() {
			window.removeEventListener('scroll', this.handleUserScroll);
		}
	}
</script>


<style scoped lang="less">


  // fade out for items that are not active in the slideshow

  .uk-slider-items > *:not(.uk-active) {
    opacity: .4;
    transition: opacity .2s ease-in;
    pointer-events: none;
  }

  .base-wrapper:focus {
     outline: 0;
  }



</style>
